import React, { Suspense } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Loading } from '../components'
import {
  Home,
  History,
  Login,
  EmailLogin,
  PhoneLogin,
  Register,
  EmailRegister,
  PhoneRegister,
  MediaPageWrapper,
  Playlist,
  Detail,
  Subscription,
  PackageGroup,
  Voucher,
  Search,
  Payment,
  PaymentComplete,
  ForgotPassword,
  ResetPassword,
  NotFound,
  AboutUs,
  Terms,
  PrivacyPolicy,
  Faqs,
  ContactUs,
  EmailVerification,
  LiveTV,
  PromoAxis,
  Stream,
  UserLicenseAgreement,
  CampaignDetail,
  TransactionHistory,
  SubscriptionHistory,
} from '../pages'

const routes = [
  {
    path: '/',
    component: Home,
    exact: true,
  },
  {
    path: '/mobile/contact-us',
    component: ContactUs,
  },
  {
    path: '/login/email',
    component: EmailLogin,
    noLogin: true,
  },
  {
    path: '/login/phone',
    component: PhoneLogin,
    noLogin: true,
  },
  {
    path: '/login',
    component: Login,
    noLogin: true,
  },
  {
    path: '/register/email',
    component: EmailRegister,
    noLogin: true,
  },
  {
    path: '/register/phone',
    component: PhoneRegister,
    noLogin: true,
  },
  {
    path: '/register',
    component: Register,
    noLogin: true,
  },
  {
    path: '/playlists/:playlistId',
    component: Playlist,
  },
  {
    path: '/package-group/:packGroupId',
    component: PackageGroup,
    loggedIn: true,
  },
  {
    path: '/history',
    component: History,
    loggedIn: true,
  },
  {
    path: '/transaction-history',
    component: TransactionHistory,
    loggedIn: true,
  },
  {
    path: '/subscription-history',
    component: SubscriptionHistory,
    loggedIn: true,
  },
  {
    path: '/subscription',
    component: Subscription,
    loggedIn: true,
  },
  {
    path: '/voucher',
    component: Voucher,
    loggedIn: true,
  },
  {
    path: '/redeem',
    component: Voucher,
    loggedIn: true,
  },
  {
    path: '/search',
    component: Search,
  },
  {
    path: '/payment',
    component: Payment,
    exact: true,
  },
  {
    path: '/payment/:planId',
    component: Payment,
    exact: true,
  },
  {
    path: '/payment/:planId/:method',
    component: Payment,
    exact: true,
  },
  {
    path: '/payment/:planId/:method/:promoCode',
    component: Payment,
    exact: true,
  },
  {
    path: '/stream/:channelID?',
    component: Stream,
  },
  {
    path: '/live/:channelID?',
    component: LiveTV,
  },
  {
    path: '/campaign/:campaignId?',
    component: CampaignDetail,
  },
  {
    path: '/forgot-password',
    component: ForgotPassword,
  },
  {
    path: '/email-verification',
    component: EmailVerification,
  },
  {
    path: '/reset-password',
    component: ResetPassword,
  },
  {
    path: '/about-us',
    component: AboutUs,
  },
  {
    path: '/terms',
    component: Terms,
  },
  {
    path: '/privacy-policy',
    component: PrivacyPolicy,
  },
  {
    path: '/faqs',
    component: Faqs,
  },
  {
    path: '/end-user-license-agreement',
    component: UserLicenseAgreement,
  },
  {
    path: '/not-found',
    component: NotFound,
  },
  {
    path: '/payment/:payType/success',
    component: PaymentComplete,
    loggedIn: true,
  },
  {
    path: '/payment',
    component: Payment,
  },
  {
    path: '/promopage/axis2003',
    component: PromoAxis,
    noLogin: true,
  },
  {
    path: '/:programType/:mediaId',
    component: Detail,
  },
  {
    path: '/:pageName',
    component: MediaPageWrapper,
  },
]

const withAuth = (BaseComponent) => {
  const WithAuth = (props) => {
    const authState = useSelector((state) => state.auth)

    return <BaseComponent {...props} token={authState.token} />
  }

  return WithAuth
}

const renderRoute = () => {
  return routes.map(
    ({ path, component: Component, exact, noLogin, loggedIn }) => {
      if (noLogin) {
        return (
          <Route
            exact={exact}
            key={path}
            path={path}
            component={withAuth((props) => {
              // Save click_id value of query params sent from Showtime to local storage
              // This click_id only exists in the login and register paths
              const pathName = props.location.pathname
              if (pathName.includes('login') || pathName.includes('register')) {
                const query = new URLSearchParams(props.location.search)
                const clickId = query.get('click_id')

                clickId && localStorage.setItem('clickId', clickId)
              }

              return props.token ? (
                <Redirect to={{ pathname: '/' }} />
              ) : (
                <Component {...props} />
              )
            })}
          />
        )
      }

      if (loggedIn) {
        return (
          <Route
            exact={exact}
            key={path}
            path={path}
            component={withAuth((props) =>
              props.token ? (
                <Component {...props} />
              ) : (
                <Redirect to={{ pathname: '/' }} />
              )
            )}
          />
        )
      }

      return (
        <Route exact={exact} key={path} path={path} component={Component} />
      )
    }
  )
}

export default function Routes() {
  return (
    <Suspense fallback={<Loading height='100vh' />}>
      <Switch>
        {renderRoute()}
        <Redirect to='/not-found' />
      </Switch>
    </Suspense>
  )
}

export { default as MobileRoutes } from './mobile'
